<div
  class="viewswitch"
  [class.viewswitch--collapsed]="collapsed()"
  role="group"
  [attr.aria-label]="ariaLabel()"
  [attr.data-cy]="dataCy()">
  @for (seg of segments(); track seg.id) {
    <button
      type="button"
      class="viewswitch__opt"
      [class.is-active]="seg.id === activeId()"
      [attr.aria-current]="seg.id === activeId() ? 'page' : null"
      (click)="onSegment(seg.id)"
      [attr.data-cy]="dataCy() + '-' + seg.id">
      <lkt-icon [name]="seg.icon" [size]="19" />
      @if (!collapsed()) {
        <span class="viewswitch__label">{{ seg.label }}</span>
      } @else {
        <span class="viewswitch__tip">{{ seg.label }}</span>
      }
    </button>
  }
</div>
